export enum UploadFileActionEnum {
  Replace = 'replace',
  NewOnly = 'newOnly',
  KeepBoth = 'keepBoth',
}
